<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause">
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          E数通注册及服务协议
        </p>
        <p class="distance_50">
          欢迎您与深圳前海大数金融服务有限公司（简称“大数金融”）订立本服务协议（简称“本协议”）并注册成为“E数通”会员，并使用大数金融基于网络提供的技术服务（简称“本服务”）实现您的个人经营或消费贷款需求。
        </p>
        <p class="distance">
          <span style="color: #000;font-weight:bold"
            >大数金融在此特别提醒您：</span
          >
        </p>
        <p class="distance_50" style="color:#000;font-weight:bold">
          在您决定成为会员前，请仔细阅读并完全理解本的全部内容，尤其是下文第四条的用户保证承诺、第九条的风险提示、第十二条的免责声明。您必须在接受本协议所包含的条款、条件和即时刊登的通告，并且遵守有关互联网及/或的相关法律、规定与规则的前提下，才能进入会员注册程序。您只有成功注册成为E数通会员，才能使用我们提供的会员服务。如您不同意本协议的任意内容，请勿注册或使用本服务。如您通过进入注册程序并勾选"我同意"，即表示您与深圳前海大数金融服务有限公司已达成协议，自愿接受本协议的所有内容。此后，您不得以未阅读本协议内容作任何形式的抗辩。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">定义</p>
        <p class="distance_50">
          1 大数金融：指深圳前海大数金融服务有限公司及大数金融关联方。
        </p>
        <p class="distance_50">
          2
          大数金融关联方：深圳前海大数金融服务有限公司/深圳市大数融资担保有限公司/武汉融生融资担保有限公司
        </p>
        <p class="distance_50">
          3
          您、用户：指持有中国大陆身份证的（不包括中国香港、澳门及台湾地区）、年龄在18周岁以上且具有完全民事行为能力，通过本服务向贷款人提出借款申请，接受贷款人评估，独立承担还款义务与责任的自然人。
        </p>
        <p class="distance_50">
          4
          贷款人：指接受您的贷款申请，评估您的借款需求、风险和额度，与您订立贷款合同及向您提供贷款资金的适格放款主体。您同意本服务项下最终的贷款人可能为一家机构，也可能为多家机构。
        </p>
        <p class="distance_50">
          5
          本服务：指大数金融作为服务方通过平台向您提供的个人消费/经营贷款产品项下页面展示及申贷、还款指令传递等金融技术服务。
        </p>
        <p class="distance_50">
          6 账户： 指您以自身名义申请注册的，用以接受本服务的注册账户。
        </p>
        <p class="distance_50">
          7 用户指令：
          指用户以数据电文形式向大数金融和/或贷款人发出的意思表示，包括但不限于要求申请或取消服务的要求、承诺、请求或确认等。除非另有约定，您发出的所有指令及其内容一经作出即不可撤销或变更。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第一条 服务确认和接纳
        </p>
        <p class="distance_50">
          1.1
          您一经勾选同意本协议并按照规定的会员注册程序开始注册，即表示您已充分阅读、理解并同意接受本协议的条款和条件，并自愿签署了本协议，本协议即在您和深圳前海大数金融服务有限公司之间产生法律效力。
        </p>
        <p class="distance_50">
          1.2
          本协议内容包括本协议全部条款及已经发布的或将来可能发布的各类规则、通告。所有规则、通告为本协议不可分割的一部分,与本协议正文具有同等法律效力。
        </p>
        <p class="distance_50">
          1.3
          您一经注册即视为您同意在将来任何时刻有权根据公司业务需求、互联网的发展或中华人民共和国有关法律、法规的变化，不时地制定、修改会员服务条款或平台各类规则,并在大数金融平台上予以公布。经修订后的协议、规则一经公布，立即自动生效。会员的权利以及义务的表述，均以最新的服务条款为准。大数金融特别提醒您，应不时地关注本协议及附属规则的变更。若您在相关协议、规则内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议、规则；若您不同意相关变更,
          您可以立即停止使用本服务。同时有权不经任何告知终止、中止本协议或者限制您进入的全部或者部分板块且不承担任何法律责任。但该终止、中止或限制行为并不能豁免您在已经进行的交易项下所应承担的义务。
        </p>
        <p class="distance_50">
          1.4
          当您使用E数通服务时，您的使用行为视为您对该单项服务的协议以及大数金融在该单项服务中发出的各类公告及/或规则的同意。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第二条 服务内容
        </p>
        <p class="distance_50">
          2.1
          基于贷款产品的情况，向您提供相关信息展示的服务。为此大数金融将通过本服务页面向您展示必要的贷款产品信息，使您了解贷款产品和您的贷款情况；
        </p>
        <p class="distance_50">
          2.2
          基于您的申请，向贷款人及提供金融服务所必需的其他第三方机构传递您的贷款申请、身份验证信息、信用信息等，以便贷款人评估您的信用以及第三方机构提供服务，并将贷款人和第三方机构反馈的信息传递给您。
        </p>
        <p class="distance_50">
          2.3
          基于您的贷款情况，通过本协议约定的通知方式向您提示资金到账、到期还款、运营活动等相关信息，以便您及时、便利地使用贷款服务。上述通知提醒以实际送达的为准。
        </p>
        <p class="distance_50">
          2.4
          为了提高服务质量和用户体验，大数金融作为技术服务提供方将负责数据分发,协助您与贷款人之间签署并保留贷款合同等法律文件，接受您的贷款咨询与投诉，协助贷款人做好贷后管理。
        </p>
        <p class="distance_50">
          2.5
          您在任一移动终端上首次使用本服务申请贷款时，在进行身份验证时，贷款人或银行或支付机构将向您在银行预留的手机号发送验证码进行身份验证。
        </p>
        <p class="distance_50">
          2.6
          大数金融在任何时候均有权验证您的相关信息，并据此评估您的信用状况。大数金融有权基于自主判断拒绝向您提供本服务或拒绝您使用平台服务。
        </p>
        <p class="distance_50">
          2.7
          用户通过使用嵌入有钱花服务的平台及应用程序等多种渠道，均可访问并使用平台提供的信息及金融服务。大数金融有权不时调整本服务的营销名称及访问渠道。
        </p>
        <p class="distance_50">
          2.8
          大数金融保留在无须发出书面通知，仅在平台公示的情况下暂时或永久地更改或停止部分服务的权利。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第三条 服务费用
        </p>
        <p class="distance_50">
          3.1
          当您使用E数通服务时，大数金融暂不向您收取相关服务费用。各项服务收费以您使用服务时平台上所公示之收费方式说明或双方另行签订的协议为准。<span
            style="color: #000;font-weight:bold"
            >大数金融保留单方面订定及调整服务收费的权利。如后续为了正常运营需要向您收取费用，将采用在本服务页面公告的方式向您告知，届时您可选择是否使用本服务；如您届时选择不再使用本服务，贷款人可能会要求您提前结清贷款</span
          >。
        </p>
        <p class="distance_50">
          3.2
          您在使用服务过程中可能需要向第三方（如银行或第三方支付公司等）支付一定的费用，具体收费标准详见第三方平台相关页面或平台的提示。您使用服务过程中进行的代收、代付指令传递及取现等服务涉及大数金融与银行、第三方支付机构等第三方的合作。<span
            style="color: #000;font-weight:bold"
            >您了解并同意，大数金融并不是银行或支付机构，不提供前述服务，不对前述服务的成功做任何承诺，也不承担与此相关的责任，您与第三方之间就费用支付等事项产生的争议或纠纷，与大数金融无关</span
          >。
        </p>
        <p class="distance_50">
          3.3
          您在E数通进行交易而与其他方签订协议的，其他方有权按照协议的约定向您收取相关费用。
        </p>
        <p class="distance_50">
          3.4
          您因进行交易而发生的所有应纳税赋，以及相关硬件、软件、通讯、网络服务及其他方面的费用均由您自行承担。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第四条 用户保证与承诺
        </p>
        <p class="distance_50">
          4.1
          保证严格遵守中国现行法律、法规、政府规章及其他应该遵守的规范性文件，不在E数通从事危害国家安全、洗钱、套现、传销等任何违法活动或者其他有违社会公共利益或公共道德的行为。
        </p>
        <p class="distance_50">
          4.2
          保证合法使用大数金融提供的资讯或服务，遵守所有与大数金融服务有关的协议、规则和程序，清楚了解互联网产品，特别是个人消费贷款产品的使用方法和使用惯例，认可数据电文形式的合同效力。
        </p>
        <p class="distance_50">
          4.3未经大数金融事先书面授权，不使用任何非法手段擅自进入大数金融的未公开系统。保证不冒用、盗用或以其他未经授权方式使用他人资料进行注册或者冒用、盗用他人名义使用E数通服务。
        </p>
        <p class="distance_50">
          4.4
          保证拥有合法的权利和资格在大数金融发布交易信息并进行交易，且保证前述行为不侵害任何第三方合法权益；保证自己的行为不会导致大数金融遭受任何第三方提起的索赔、诉讼或行政责任；保证若因自己的行为导致大数金融遭受任何第三方提起的索赔、诉讼或行政责任时自己将无条件先行承担相应责任并使大数金融免责。
        </p>
        <p class="distance_50">
          4.5
          承诺自己通过上传的信息均真实有效，自己向大数金融提交的任何资料均真实、有效、完整、详细、准确。
        </p>
        <p class="distance_50">
          4.6
          承诺E数通平台所有内容和服务，包括但不限于平台的整体结构、网页设计、文字、图片、图表、软件、视频文件、音频文件、广告以及平台为您提供的其它信息或资料，其知识产权属大数金融平台或其他相关方所有，未经大数金融或其他相关方许可，不作任何商业目的的复制或者以其它方式进行非法使用。
        </p>
        <p class="distance_50">
          4.7
          承诺在国家生效法律文书或行政处罚决定确认自己存在违法行为，或者有足够事实依据可以认定自己存在违法或违反本协议的行为，以及自己借款逾期未还的情况下，大数金融有权在任何形式的媒体上公布自己的违法、违约行为，并将相关信息计入任何与自己相关的信用资料，以及对自己的您账户采取暂停或关闭等措施。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第五条 会员注册
        </p>
        <p class="distance_50">
          5.1
          大数金融仅向符合中华人民共和国法律规定的具有完全民事权利能力和民事行为能力，能够独立承担民事责任的自然人和机构提供服务。若您不符合此等条件，请立即停止注册或停止使用本服务。若您违反前述限制注册使用大数金融的，您的监护人应对您的行为承担所有责任。
        </p>
        <p class="distance_50">
          5.2
          您在注册大数金融时必须提供您本人真实、最新、有效及完整的信息资料，并保证电子邮件地址、联系电话、联系地址、邮政编码等内容的有效性及安全性，保证大数金融及其他可以通过上述联系方式与您进行联系。若您提供任何不真实、不准确、不完整或不能反映当前实际情况的资料，或大数金融有合理理由怀疑该等资料不真实、不准确、不完整或不能反映当前情况，大数金融有权拒绝您的申请或者撤销您的资格，并拒绝您在目前或将来以任何形式使用大数金融您服务，并不予任何赔偿或者退还任何已收取的服务费用。
        </p>
        <p class="distance_50">
          5.3
          如您代表一家公司或其他法律主体进行注册登记，则您声明和保证，您已经获得该公司或其他法律主体的充分、完整授权，该公司或其他法律主体自愿且无条件地接受本协议条款的约束。
        </p>
        <p class="distance_50">
          5.4
          您必须维持并及时更新您的资料，使其保持真实、准确、完整和反映当前情况，否则由此造成的权利不能全面有效地行使的责任由您自行承担，大数金融有权因此取消您的资格，并不予任何赔偿或者退还任何已收取的服务费用。
        </p>
        <p class="distance_50">
          5.5
          <span style="color:#000;font-weight:bold"
            >若您冒用、盗用或以其他未经授权方式使用他人资料进行注册登记的，由此引起的一切后果概由您独立承担。大数金融获悉或怀疑您未经授权使用他人资料注册的,可以采取暂停或者终止为您提供服务、立即注销您的账户等措施而无须承担任何责任。</span
          >
        </p>
        <p class="distance_50">
          5.6
          您在注册，即视为您同意向您注册时填写的电子邮箱、手机号码发送与服务有关的电子邮件或短信。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第六条 会员账户和密码
        </p>
        <p class="distance_50">
          6.1
          您遵照注册提示，成功注册之后，即建立了自己的E数通账户，该账户具有唯一性、专有性，您承诺妥善保管自己的账户。您可以通过用户名和手机验证码登录账户，使用平台服务。您注册登记的手机号码就是您在大数金融的用户名。
        </p>
        <p class="distance_50">
          6.2
          您应妥善保管自己的用户名和手机验证码，确保账户及密码的机密安全。您不得将账户转让、赠与或授权给第三方使用。
        </p>
        <p class="distance_50">
          6.3
          <span style="color:#000;font-weight:bold"
            >如您发现有他人冒用或盗用您的账户及密码或任何其他未经合法授权之情形时，应立即以有效方式通知大数金融，要求暂停相关服务。同时，您理解大数金融对您的请求采取行动需要合理期限，而在大数金融采取实际行动之前，您应对任何或所有由未经授权人士使用此服务或此服务被用作未经授权用途负责，大数金融对已执行的指令及(或)所导致的您的损失不承担任何责任。</span
          >
        </p>
        <p class="distance_50">
          6.4
          冒用或者盗用他人账户及密码的，大数金融及其合法授权主体保留追究实际使用人法律责任的权利。
        </p>
        <p class="distance_50">
          6.5
          大数金融不会通过电话、短信或电子邮件方式要求您提供您的账户、密码或其他安全信息，如果您收到声称来自大数金融的任何该等要求，您不应对该等要求作出任何回应。否则，由此造成的损失由您自行承担。
        </p>
        <p class="distance_50">
          6.6
          您注册成功之后系统将自动为您生成注册号，注册号是您在大数金融的永久身份标识，终生不变。为充分保障隐私，我们在交易过程中将以您的注册号替代您的姓名和/或用户名。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第七条 账户注销、暂停、终止或限制访问
        </p>
        <p class="distance_50">
          7.1
          您理解，需要定期或不定期地对提供服务的系统或相关的设备进行检修、维护，或对系统进行升级、改造。如因此类情况而造成服务在合理时间内的中断，大数金融无需为此承担任何责任。但大数金融应尽可能事先进行通告并根据情况在相应服务页面提前作出通知。
        </p>
        <p class="distance_50">
          7.2
          您决定不再使用会员账户时，应首先清偿所有应付款项（包括但不限于借款本金、利息、罚息、违约金、服务费、管理费等），再将您账户下所对应的可用款项（如有）全部提现或者向大数金融发出其它合法的支付指令，并向大数金融申请注销（或永久冻结）该会员账户，经大数金融审核同意后可正式注销会员账户。
        </p>
        <p class="distance_50">
          7.3
          会员账户和密码仅限于您本人使用，您不得以任何形式转让或出借、出租给他人使用，如果发现同一账户和密码在同一时间内被多人同时登录使用，大数金融有权暂停、终止或限制该用户访问直至取消该用户的会员资格，并不予任何赔偿或者退还任何已收取的服务费用。
        </p>
        <p class="distance_50">
          7.4
          如发生下列任何一种情形，大数金融有权不经通知而中断或终止向您提供本协议项下的服务而无需对您或任何第三方承担任何责任：
        </p>
        <p class="distance_50">
          7.4.1 您连续超过365天的时间内未以您的用户名和密码登录平台；
        </p>
        <p class="distance_50">
          7.4.2 您的行为违反法律法规或者本协议的约定；
        </p>
        <p class="distance_50">
          7.4.3 按照法律规定或主管部门的要求；
        </p>
        <p class="distance_50">
          7.4.4 出于交易安全或其他必要情形；
        </p>
        <p class="distance_50">
          7.5
          大数金融有权基于反洗钱及其它防范利用平台侵害他人财产权利目的，对您发出的服务指令中明显违背常规逻辑的行为采取临时冻结措施且无需对您或任何第三方承担任何责任。您违背常规逻辑的行为包括但不限于：a、在1个月内3次或以上申请借入资金并且均在1个月内提前偿还的；b、其它违背常规逻辑的行为。大数金融将在冻结后一个工作日内通过预留电话与您沟通，经电话录音确认您操作的真实性后决定是否解冻及\或向公安机关报案。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第八条 会员指示
        </p>
        <p class="distance_50">
          8.1
          您使用用户名和密码登录大数金融平台后，可以按照相关服务流程和权限在网上向大数金融发出服务指示。有关此服务的指示，必须按大数金融规定的方式发出且经大数金融实际收到后，才视为已由大数金融收到。
        </p>
        <p class="distance_50">
          8.2
          <span style="color:#000;font-weight:bold"
            >大数金融通过用户名和密码来识别您的身份，您使用用户名和密码登录后在大数金融进行的一切行为或言论均视为您本人行为及真实意思表示，由此产生的法律后果由您本人承担。因黑客、病毒或密码被盗、泄露等非大数金融原因导致您账户遭他人非法使用等一切责任、损失概由您本人承担，大数金融不承担任何责任。</span
          >
        </p>
        <p class="distance_50">
          8.3
          您在使用用户名和密码登录大数金融平台后的任何指示，一经发出，在未经大数金融书面同意的情况下，一概不得取消或撤回。所有此等已发出的指示，不论由您本人或声称为您的任何其它人士发出，经大数金融按其诚信理解并执行后，即不可撤销，且对您有约束力。除核证您的用户名和密码外，大数金融并无任何责任核对任何发出此类指示的人士身份或权限，或核对此类指示的真实性。
        </p>
        <p class="distance_50">
          8.4
          若大数金融获悉或怀疑您存在不遵守本协议或使用服务存在不安全的情况或其它可疑情况，大数金融可以完全自由地酌情决定，拒绝执行或延期执行客户指示而无须承担任何责任。在该等情况下,大数金融将在可能的限度内，尽快通知客户。
        </p>
        <p class="distance_50">
          8.5
          大数金融仅执行大数金融认为合理且实际可行的指示，并将遵照一般业务惯例及程序处理。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第九条 风险提示
        </p>
        <p class="distance_50">
          9.1
          您了解并同意，任何通过大数金融进行的交易并不能必然避免以下风险的产生，大数金融没有义务为如下风险负责。您应依赖于个人独立判断进行交易，并对个人做出的判断承担全部责任：
        </p>
        <p class="distance_50">
          9.1.1
          宏观经济风险：因宏观经济形势变化，可能引起价格等方面的异常波动，您有可能遭受的损失；
        </p>
        <p class="distance_50">
          9.1.2
          政策风险：有关法律、法规及相关政策、规则发生变化，可能引起价格等方面异常波动，您有可能遭受的损失；
        </p>
        <p class="distance_50">
          9.1.3 利率风险：市场利率变化可能对购买或持有产品的实际收益产生的影响；
        </p>
        <p class="distance_50">
          9.1.4 不可抗力因素导致的风险；
        </p>
        <p class="distance_50">
          9.1.5
          违约风险：因其他交易方无力或无意愿按时足额履约，您有可能遭受的损失；
        </p>
        <p class="distance_50">
          9.1.6 因您本人的过错导致的任何损失
          ，该过错包括但不限于：决策失误、操作不当、遗忘或泄露密码、密码被他人破解、会员使用的计算机系统被第三方侵入、会员委托他人代理交易时他人恶意或不当操作而造成的损失。
        </p>
        <p class="distance_50">
          9.2
          大数金融不对任何个人会员及/或任何交易提供任何担保或条件，无论是明示、默示或法定的。大数金融不能完全保证平台内容的真实性、充分性、可靠性、准确性、完整性和有效性，也无需承担任何由此引起的法律责任。
        </p>
        <p class="distance_50">
          9.3
          以上并不能揭示您通过大数金融进行交易的全部风险及市场的全部情形。您在做出交易决策前，应全面了解相关交易，根据自身的交易目标、风险承受能力和资产状况等谨慎决策，并自行承担全部风险。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第十条 用户信息与隐私保护
        </p>
        <p class="distance_50">
          10.1
          基于对用户贷款资质综合情况的正确评估，E数通可能自行通过公开\私人资料来源\合作的第三方机构（包括公共网络、有权数据机构、获得用户授权的其他数据机构）收集用户信息和行为信息，并对收集结果根据本条款协议及有关文件进行查看、使用和留存操作。大数金融承诺仅收集“E数通”认为就此目的及达成该目的所必须的关于用户的信息，用户对此予以认可接受。
        </p>
        <p class="distance_50">
          10.2
          基于对用户贷款资质综合情况的正确评估这一目的，用户同意并授权“E数通”可以自行或通过合作的第三方机构对用户提交或“E数通”搜集的用户基础隐私信息和其他隐私信息进行核实，并对获得的核实结果根据本协议本条款及有关文件进行查看、使用和留存操作。
        </p>
        <p class="distance_50">
          10.3
          基于方便用户及时获取还款信息这一目的，用户授权并同意“E数通”可以获取、查询及导入用户在大数金融申请的贷款及贷款担保信息，为用户提供“还款计划”相关服务。
        </p>
        <p class="distance_50">
          10.4
          大数金融对于您提供的、大数金融自行收集的、经认证的您信息将按照本协议予以保护、使用或者披露。用户信息包括用户注册信息、个人信息、行为信息、联系人信息、贷款及担保信息。
        </p>
        <p class="distance_50">
          10.5
          大数金融将依照国家有关法律法规，采取各种严格的措施确保您的信息安全，以防止未经合法授权的任何人、任何机构，包括本公司未经授权的员工或分支机构获取您的信息。但是，鉴于技术限制，大数金融不能确保您的全部私人通讯及其他个人资料不会被泄露出去。
        </p>
        <p class="distance_50">
          10.6
          您同意，大数金融有权出于为您提供与本服务条款有关服务的目的，将本协议项下有关事务委托第三方处理，或将您的个人信息资料提供给大数金融认为必需的第三方，包括但不限于大数金融的关联公司、代理人、合作方、外包作业机构等。
        </p>
        <p class="distance_50">
          10.7
          您同意并授权大数金融基于促成交易、履行协议、解决争议、调停纠纷、保障大数金融您交易安全等合法目的而使用其您资料（包括但不限于大数金融持有的有关您的档案中的资料，大数金融从您目前及以前在大数金融上的活动所获取的其他资料，以及大数金融通过其他合法方式自行收集的资料）。
        </p>
        <p class="distance_50">
          10.8
          大数金融可能通过公开及私人资料来源收集您的额外资料，以更好地了解您的需求，并为您度身订造大数金融服务、解决争议或确保在大数金融平台进行安全交易。
        </p>
        <p class="distance_50">
          10.9
          为防止个别您通过大数金融从事欺诈、洗钱或其他违法犯罪活动，保护大数金融及广大您的合法权益，您同意并授权大数金融可通过人工或自动程序对您的个人信息资料进行评价。
        </p>
        <p class="distance_50">
          10.10
          在不透露单个您隐私资料的前提下，大数金融有权对整个您数据库进行分析并对您数据库进行商业上的利用。
        </p>
        <p class="distance_50">
          10.11
          您不得在大数金融提供的交易活动中，要求大数金融提供其他您的个人资料。
        </p>
        <p class="distance_50">
          10.12
          司法机关、政府部门或其他监管机构根据有关法律、法规、规章及其他政府规范性文件的规定和程序，要求提供您的个人资料及交易信息的，有可能据此提供您的相关信息资料。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第十一条 知识产权保护
        </p>
        <p class="distance_50">
          11.1
          所有内容和服务，包括但不限于平台的整体结构、网页设计、文字、图片、图表、软件、视频文件、音频文件、广告以及为您提供的其它信息或资料，其知识产权属或其他相关方所有。未经或其他相关方许可，任何人不得为了商业目的进行复制或者以其它方式进行非法使用。
        </p>
        <p class="distance_50">
          11.2 任何未经授权许可而使用内容的行为均属于违法行为,
          大数金融保留追究相关使用人法律责任的权利。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第十二条 免责声明
        </p>
        <p class="distance_50">
          12.1
          大数金融不对本服务提供任何形式的保证，包括但不限于本服务符合您的需求，本服务不受干扰、及时提供或免于出错。
        </p>
        <p class="distance_50">
          12.2 对于本协议第七条造成的服务变更、中断或终止，大数金融不承担责任。
        </p>
        <p class="distance_50">
          12.3
          您无法从大数金融获得借款的担保或允诺，无论是明示、默示的。大数金融向您提供的各种信息及资料不构成贷款的申请建议，请您独立判断做出决策。在借款过程中，您与贷款人之间发生的纠纷，由您与贷款人自行解决。
        </p>
        <p class="distance_50">
          12.4
          您理解并同意贷款人有权自主决定是否向您授予额度或发放贷款，大数金融不承诺您签署本协议后一定会获得信用额度或贷款，是否获得信用额度或贷款以实际贷款人审核结果为准。
        </p>
        <p class="distance_50">
          12.5
          您知晓并同意因业务需要（如贷款人资金不足或授信政策变化等），大数金融可协调已给予您授信的贷款人终止对您的授信，并安排您向其他贷款人申请授信和借款，您承诺不因此向大数金融或各贷款人提起抗辩。
        </p>
        <p class="distance_50">
          12.6
          会员信息主要由您自行提供或发布，您应保证所有您提供的信息的真实、及时和完整，您应对信息虚假、缺失和遗漏导致其他方的损失承担全部责任，大数金融对此不承担任何责任。
        </p>
        <p class="distance_50">
          12.7
          任何大数金融之外的第三方机构或个人所提供的服务，其服务品质及内容由该第三方自行、独立负责。您享用相关服务时产生的争议、纠纷及损失，大数金融不承担任何责任。
        </p>
        <p class="distance_50">
          12.8
          因不可抗力或服务器死机、网络故障、数据库故障、软件升级等问题造成的服务中断和对您个人数据及资料造成的损失，大数金融不承担任何责任，亦不予赔偿，但将尽力减少因此而给您造成的损失和影响。
        </p>
        <p class="distance_50">
          12.9
          因黑客、病毒或密码被盗、泄露等非大数金融原因所造成损失概由您本人自行承担。
        </p>
        <p class="distance_50">
          12.10
          您须安全使用账户，妥善保存平台的用户名、密码，对您保管不善造成的损失大数金融不承担责任。如您使用他人账户，须事先获得他人同意。一旦输入正确的用户名和密码，即视您为已获得他人同意。您与他人之间因此产生的任何纠纷与大数金融无关，对您或他人的损失大数金融不承担责任，并且如造成大数金融损失的，大数金融将保留追索的权利。
        </p>
        <p class="distance_50">
          12.11
          当司法机关、政府部门或其他监管机构根据有关法律、法规、规章及其他政府规范性文件的规定和程序，要求提供您信息资料，对据此作出的任何披露，概不承担责任。
        </p>
        <p class="distance_50">
          12.12
          除双方另有书面约定外，在任何情况下，大数金融对本协议所承担的违约赔偿责任总额不超过向您收取的当次大数金融服务费用总额。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第十三条 赔偿
        </p>
        <p class="distance_50">
          13.1
          您因违反本协议或本协议项下的其他文件，或违反了任何法律、法规的规定，给大数金融造成损失的，应予赔偿，赔偿范围包括但不限于大数金融的直接损失、间接损失以及维权费用等。
        </p>
        <p class="distance_50">
          13.2您因违反前款规定而侵害了第三方的权利，导致大数金融遭受任何第三方提起的索赔、诉讼或行政责任，您承诺无条件承担相应责任并使大数金融免责。若因此给大数金融造成损失的，应予赔偿，赔偿范围包括但不限于大数金融的维权费用、名誉损失以及大数金融向第三方支付的补偿金等。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第十四条 签约与通知
        </p>
        <p class="distance_50">
          14.1
          在平台上交易需订立的合同一律采用电子合同方式。您使用会员账户和密码登陆大数金融后，根据大数金融的相关规则，在平台上通过点击确认或类似方式签署的电子合同即视为您本人真实意愿并以会员本人名义签署的合同，具有法律效力，无需当面验证您的身份。您应妥善保管账户密码等账户信息，不得以账户密码等账户信息被盗用或其他理由否认已订立的合同的效力或不按照该等合同履行相关义务。
        </p>
        <p class="distance_50">
          14.2
          除非另有书面约定，大数金融向您个人发出的任何通知均以电子邮件或者手机短信形式发送到通知发出之时您资料所记载的电子邮件地址或/和手机号码，电子邮件或者短信一经发出即视为送达并产生相应法律效力。您应密切关注邮箱及手机信息。
        </p>
        <p class="distance_50">
          14.3
          本合同各方确认以本合同中预留的联络邮箱，作为双方之间往来及仲裁时仲裁机构送达相关材料的送达地址；并以预留的手机号码为短信通知号码。合同任何一方向对方及仲裁机构向双方发出的任何通知，以电子邮件或短信等形式发出，送至本合同约定邮箱或手机号码，即视为送达。如一方需要变更联络邮箱或手机号码的，应当与对方协商一致，并得到对方确认。
        </p>
        <p class="distance_50">
          14.4
          您同意大数金融按照通知发出之时您资料所记载的电子邮件或/和手机号码发出通知，大数金融不对您未能收到电子邮件或短信通知承担任何责任。
        </p>
        <p class="distance_50">
          14.5
          您确认并且同意自行主动及时登录我的账户或电子邮箱收取和查看每一份电子帐单/电子通知，以确定是否存在基于任何原因（包括但不限于伪造、变造、欺诈、无权限、或客户或任何其他人士的过失）所产生的任何错误、不一致等。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第十五条 法律适用与争议解决
        </p>
        <p class="distance_50">
          15.1
          本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律，没有相关法律规定的，参照国际惯例和/或行业惯例。
        </p>
        <p class="distance_50">
          15.2
          凡因本协议产生的争议，双方应友好协商解决。协商不成的，任何一方均可向深圳国际仲裁院提出仲裁申请，按照仲裁时该会现行有效的网络仲裁规则进行网络仲裁并进行书面审理。仲裁裁决是终局的，对双方均有约束力。
        </p>
        <p class="distance" style="color:#000;font-weight:bold">
          第十六条 修订与解释
        </p>
        <p class="distance_50">
          16.1 大数金融保留对本协议进行修订、增补和解释的权利。
        </p>
        <p class="distance_50">
          请仔细阅读以上条款，同意注册请勾选"我同意"按钮。
        </p>
        <div style="text-align:right">
          <p>深圳前海大数金融服务有限公司</p>
          <p>2019/09/01</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  text-indent: 6px;
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
